<template>
  <v-container class="py-0">
    <IntroText
      :intro-one="pageItem.MainText"
      :pageItem="pageItem"
    />
    <v-row v-if="news && newsItem.length !== 0">
      <v-col v-for="(item, index) in newsItem" :key="item.Code" cols="12" sm="6">
        <NuxtLink class="text-decoration-none" v-if="item.Code && item.NameUrl" :to="{
            path: $methods.pageUrlByPageType('DN')  + '/' + item.NameUrl
          }">
          <v-row>
            <v-col cols="4" sm="4" md="4" lg="3" xl="2" class="pt-0">
              <NVEAROverviewImg :item="item"/>
            </v-col>
            <v-col v-if="item.Code" cols="8" sm="8" md="8" lg="9" xl="10" class="pt-0">

              <h2 class="pt-0 h2news">
                {{ item.Title }}
              </h2>
              <p class="pt-2 pb-0 text-secondary"><strong>{{ item.DateStart }}</strong></p>
              <p class="text-text pt-0" v-if="item.MainText">
                <span >{{ $helpers.stripHtml(item.MainText, 175)}}</span>

              </p>
            </v-col>
          </v-row>
        </NuxtLink>
      </v-col>
    </v-row>
    <PaginationUrl :total="news?.length || 0" :per-page="perPage" />

  </v-container>
</template>
<script setup>
import PaginationUrl from "@/components/Base/PaginationUrl.vue";
import IntroText from "@/components/Base/introText.vue";
import NVEAROverviewImg from "@/components/Base/NVEAROverviewImg.vue";

const props = defineProps({
  pageItem: {
    type: Object,
    default: "",
  },
});

const dataAll = useDataAll();
const { $apiMethods, $methods, $helpers } = useNuxtApp();
const perPage = 4;

const news = await $apiMethods.loadJSONApi(
  $apiMethods.getOverviewNewsEventvacancyItem("newsOverview")
).catch(err => {
  console.log(err);
  throw createError({ statusCode: 503, statusMessage: "news items can not be loaded" });
});

const { currentPage } = await usePageQuery(news?.length, perPage);

const newsItem = computed(() => {
  return [...(news || [])]
    .sort((a, b) => new Date(b.DateStart) - new Date(a.DateStart))
    .slice((currentPage.value - 1) * perPage, currentPage.value * perPage);
});
</script>
